(function () {
  const pushEvent = (eventName, details) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...(details || {}) });
  };

  const setBusinessType = (value) => {
    const select = document.querySelector('select[name="contact[Business type]"]');
    if (!select || !value) return;

    const matchingOption = Array.from(select.options).find((option) => option.value === value);
    if (matchingOption) {
      select.value = value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  document.addEventListener("click", (event) => {
    const trackedLink = event.target.closest("[data-wp-event]");
    if (trackedLink) {
      pushEvent(trackedLink.dataset.wpEvent, {
        link_text: trackedLink.textContent.trim(),
        link_url: trackedLink.getAttribute("href") || "",
        audience: trackedLink.dataset.businessType || "",
        placement: trackedLink.dataset.wpPlacement || "",
      });

      if (trackedLink.dataset.businessType) {
        setBusinessType(trackedLink.dataset.businessType);
      }
    }

    const calendarAction = event.target.closest(
      ".section-event-calendar a, .section-event-calendar button, .section-event-calendar [x-data^='xEventCalendar'] > .button"
    );
    if (calendarAction) {
      pushEvent("wholesale_trade_show_action", {
        link_text: calendarAction.textContent.trim(),
      });
    }
  });

  document.addEventListener("submit", (event) => {
    if (event.target.closest("[data-wholesale-inquiry]")) {
      pushEvent("wholesale_inquiry_submit", { form_id: "WholesaleInquiryForm" });
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const params = new URLSearchParams(window.location.search);
    setBusinessType(params.get("audience"));

    if (document.querySelector("[data-wholesale-inquiry-success]")) {
      pushEvent("wholesale_inquiry_success", { form_id: "WholesaleInquiryForm" });
    }
  });
})();
